import * as _ from "lodash";
import { TeamColorDataProvider } from "../data-provider/team-color.dp";
import { Invite } from "./invite.model";
import { User } from "./user.model";

export class Team {
    public readonly requestIgnoreList = ["InviteConstructor"];

    public tid: number | string | null = null;
    public tname = "";
    public users: User[] = [];
    public invites: Invite[] = [];
    public tstatus = "Active";
    public tcolor: string;

    public images: any;
    public initials: string | undefined;

    public userscount?: any;

    // Members the edit dialog loaded; the server applies only the difference.
    public original_uids?: any[];
    public original_invite_ids?: any[];

    private readonly modelsUtils: any;

    constructor(
        TeamColorDataProvider: TeamColorDataProvider,
        ModelsUtils: any,
        teamData?: any
    ) {
        this.modelsUtils = ModelsUtils;
        this.tcolor = TeamColorDataProvider.randomColor();

        if (teamData) {
            this.setData(teamData);
        }
    }

    indexOfMember(user: User): number {
        for (let i = 0; i < this.users.length; i++) {
            if (this.users[i].uid == user.uid) return i;
        }
        return -1;
    }

    getID(): number | string | null {
        return this.tid;
    }

    setData(teamData: any): void {
        _.merge(this, teamData);
        if (this.invites.length) {
            this.invites.forEach((invite: Invite, index: number) => {
                this.invites[index] = this.modelsUtils.invite(invite);
            });
        }
        this.getImage();
    }

    hasMember(user: User): boolean {
        return this.indexOfMember(user) > -1;
    }

    toggleMember(user: User): void {
        const teamMemberIndex = this.indexOfMember(user);
        if (teamMemberIndex > -1) {
            this.users.splice(teamMemberIndex, 1);
        } else {
            this.users.push(user);
        }
    }

    getImage(): void {
        this.images = {};
        this.initials =
            "https://eu.ui-avatars.com/api/?name=" +
            this.tname +
            "&background=" +
            this.tcolor.substr(1) +
            "&color=fff&rounded=true&bold=true&length=1";
        this.images.small = this.initials + "&size=64";
        this.images.medium = this.initials + "&size=128";
        this.images.big = this.initials + "&size=256";
    }
}
